/* eslint-disable @angular-eslint/directive-selector */
import { Directive, TemplateRef, input, output, contentChild } from '@angular/core';
import { DatatableGroupHeaderTemplateDirective } from './body-group-header-template.directive';

@Directive({
  selector: 'ngx-datatable-group-header'
})
export class DatatableGroupHeaderDirective {
  /**
   * Row height is required when virtual scroll is enabled.
   */
  readonly rowHeight = input<number | ((group?: unknown, index?: number) => number)>(0);

  readonly _templateInput = input<TemplateRef<unknown>>(undefined, { alias: 'template' });

  readonly _templateQuery = contentChild(DatatableGroupHeaderTemplateDirective, { read: TemplateRef });

  get template(): TemplateRef<unknown> {
    return this._templateInput() || this._templateQuery();
  }

  /**
   * Track toggling of group visibility
   */
  readonly toggle = output<unknown>();

  /**
   * Toggle the expansion of a group
   */
  toggleExpandGroup(group: unknown): void {
    this.toggle.emit({
      type: 'group',
      value: group
    });
  }

  /**
   * Expand all groups
   */
  expandAllGroups(): void {
    this.toggle.emit({
      type: 'all',
      value: true
    });
  }

  /**
   * Collapse all groups
   */
  collapseAllGroups(): void {
    this.toggle.emit({
      type: 'all',
      value: false
    });
  }
}
